module.exports = __webpack_public_path__ + "img/kiatnakin.6ff4b04b.jpg";